import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

export default function AssetScanAssetsPage() {
  const { t } = useTranslation();
  return <Typography sx={{ p: 2 }}>{t("assetScan.placeholder")}</Typography>;
}
